import _ from 'lodash';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Icon, Label } from 'semantic-ui-react';
import { useAppUserAccess } from 'global/cnr/contexts/useHelpers/useAppUserAccess'
import { ParentContext } from '../../../../global/cnr/contexts/ParentContext';
import { createInitials } from '../../../../global/common/dataAdjust';
import { formatItem, formatTypes, timeConvertor } from '../../../../global/common/dateFormatting';
import { uniqueKey } from '../../../../global/common/keys';
import { useElementOnScreen } from '../../../../global/components/sem/visibleElements';
import { SeasonMatchesContext } from '../../cnr/contexts/SeasonMatchesContext';
import { SportsMatchContext } from '../../cnr/contexts/SportsMatchContext';
import { SportsSeasonContext, matchScheduleTypes } from '../../cnr/contexts/SportsSeasonContext';
import { _matchLsTypes } from '../../cnr/reducers/SportsDataReducer';
import { matchDisplayTypes } from '../../cnr/reducers/SportsMatchReducer';
import { CreateSportsContext } from '../../create/CreateSports';
import { getSectionColor } from '../../create/sectionColors';
import { matchCalcs } from '../../helpers/match';
import MatchOptions from './MatchOptions';
import MatchResultsRt from './MatchResultsRt';
import MatchScoreDisplay from './MatchScoreDisplay';
import MatchScores from './MatchScores';
import MatchScoreTable from './MatchScoreTable';
import { MatchSummaryContext } from './MatchSummary';
import MatchTracker from './MatchTracker';
import { sportsMatchViewTypes } from './MatchWrapper';
import PoolMatch from './PoolMatch';

const key_match = 'ms-match-score'
const key_away = 'ms-match-away'
const key_home = 'ms-match-home'
const key_loc = 'ms-match-loc'
const _usePlayoff = false
const _showTeamAsHome = false
const _showSeedsOnLine = true
const _showTracker = false

const MatchSingle = (props) => {

  // match is the actual match
  // current match is the selectedMatch
  const { matchKey, teamKey, playoffDates, tournamentType, sportsMatchViewType, scheduleTypes, forOverview, forSummary } = props
  let { match } = props

  const parentContext = useContext(ParentContext)
  const { states } = parentContext ?? {}
  const { paps_state } = states
  const { pathViews } = paps_state ?? {}

  const appUserAccess = useAppUserAccess()
  const { itemAccess } = appUserAccess ?? {}

  // sportsSeasonContext
  const sportsSeasonContext = useContext(SportsSeasonContext)
  const { sportsSeason_state } = sportsSeasonContext ?? {}
  const { currentSeason_info, matchResultsInfo, _sportSeasonSettings, teams_info, _sportData, sportSettings_info } = sportsSeason_state ?? {}
  const { latestSeason, sportsKey, _sportsYearAbr, _sportsAbr, _sportsModeKey, _sportsModeSport } = currentSeason_info ?? {}
  const { showRankingsInStandings } = sportSettings_info ?? {}

  const { teams } = teams_info ?? {}
  const { useRtMatchDataView } = _sportData ?? {}
  const { _matchStatusGroups } = matchResultsInfo ?? {}
  const { allUpdates } = _matchStatusGroups ?? {}  // sportsSeasonContex  
  const { useScoreBlock, useScoreTeamBlock } = _sportSeasonSettings ?? {}

  // seasonMatchesContext
  const seasonMatchesContext = useContext(SeasonMatchesContext)
  const { seasonMatches_state, seasonMatches_handlers } = seasonMatchesContext ?? {}
  const { matchScheduleType, isTournament, selectedOpponent, matchDisplayType, rt_matchKey } = seasonMatches_state ?? {}
  const { handleMatch_editClick, handleFilter_matches } = seasonMatches_handlers ?? {}

  // sportsMatchContext
  const sportsMatchContext = useContext(SportsMatchContext)
  const { sportsMatch_state, sportsMatch_handlers } = sportsMatchContext ?? {}
  let { sportsMatch_cn } = sportsMatchContext ?? {}
  const { match_true, match_edit, showMatchScoreTable, matchAllows, matchData_rt, matchDayMatchData } = sportsMatch_state ?? {}
  const { match_rt } = matchData_rt ?? {}
  const { edit: _allowEdit_match, scores: _allowEdit_scores } = matchAllows ?? {}

  if (!match && match_true) {
    match = match_true
  }

  // createSportsContext
  const createSportsContext = useContext(CreateSportsContext)
  const _allowMatchClick = !createSportsContext

  // matchSummaryContext
  const matchSummaryContext = useContext(MatchSummaryContext)
  const { matchSummary_state } = matchSummaryContext ?? {}
  const { isSummary } = matchSummary_state ?? {}

  const [lsProps, setLsProps] = useState({})
  const [mediaResults, setMediaResults] = useState()

  const { match_dy } = matchDayMatchData ?? {}

  const [divRef, isVisible] = useElementOnScreen({ root: null, rootMargin: '0px', threshold: 1.0 })

  // match_true
  const {
    _itemKey,
    _resultsStatus,
    key,
    away,
    team,
    opponent,
    cancelled,
    home,
    isConsolation,
    isPlayoff,
    location,
    matchNumber,
    pending,
    poolKey,
    postponed,
    results_edit,
    _status,
    seeds,
    startDate,
    startTime,
  } = match_true ?? {}

  // if (_itemKey === "2WAoKdCy3O4fz9ZmVzFt") {
  //   console.log('match_single', match_true)
  // }

  const { scoreDisplay, scoreScores, resultResults } = _resultsStatus ?? {}

  const results = match_true ? match_true._results : undefined;

  const { isPast } = _status ?? {}

  const { home: home_pending, away: away_pending } = pending ?? {}
  const _isPlayoff = isPlayoff && _usePlayoff ? true : false
  const _rstz = results_edit ? results_edit : results
  const { complete } = _rstz ?? {}
  const { winner, hasScores, score, scoreDisplays } = _rstz ?? {}
  const _scoreDisplays = scoreDisplays
  const { normal: scoreDisplay_normal, scores: scoreDisplay_scores } = _scoreDisplays ?? {}

  const _location = location ? location : home ? { name: home.name } : {}
  const loc = _location ? _location.name : null
  const locIsHome = home && loc && (loc === home.name)

  const _updatedResults = allUpdates && allUpdates[_itemKey]
  const _hasResults = _rstz ? true : false

  let _showMatchOptions;

  if (rt_matchKey === _itemKey) {
    switch (matchDisplayType) {
      case matchDisplayTypes.matchOptions:
      case matchDisplayTypes.realtimeScoring:
        _showMatchOptions = true
        break;
      default:
      // nothing
    }
  }

  const teamScores = {
    away: {
      score: score ? score.away : useScoreBlock ? '' : '-',
      color: score && score.away > score.home ? 'green' : 'grey',
      winner: score && score.away > score.home ? 'winner' : ''
    },
    home: {
      score: score ? score.home : useScoreBlock ? '' : '-',
      color: score && score.home > score.away ? 'green' : 'grey',
      winner: score && score.home > score.away ? 'winner' : ''
    }
  }

  const _teamKey = teamKey ? teamKey : pathViews.teams
  const teamOnly = teamKey || (pathViews && pathViews.teams) ? true : false
  const matchOnly = pathViews && pathViews.matches ? true : false

  const getLsProps = () => {

    const { ls } = match

    let _ls = ls

    if (isPlayoff) {
      _ls = poolKey ? _.startCase(poolKey) : 'Playoffs'
      if (isConsolation) {
        _ls = _ls.replace('Finals', 'Consolation')
      } else if (isPlayoff) {
        if (poolKey !== 'finals' && matchNumber) {
          _ls += ' - #' + matchNumber
        }
      }
    }

    let _lsColor = 'black';
    let _lsIcon = 'circle thin'

    switch (match._matchCollectionKey) {
      case _matchLsTypes.exhibition:
        _lsColor = 'orange'
        break;
      case _matchLsTypes.tournament:
        _lsColor = 'purple'
        _ls = 'Tournament'
        break;
      case _matchLsTypes.nonDistrict:
        _lsColor = 'grey'
        _lsIcon = 'circle outline'
        break;
      default:
        if (matchCalcs.isNon(match._matchCollectionKey) || matchCalcs.isNon(match.sections)) {
          _lsColor = 'green'
          _lsIcon = 'circle outline'
        } else {
          _lsColor = isPlayoff ? 'blue' : 'green'
        }
    }

    setLsProps({ _ls, lsColor: _lsColor, lsIcon: _lsIcon })
  }

  useEffect(() => {
    if (match) {
      if (_showTeamAsHome) {
        if (match && match.home && match.home.id === _teamKey) {
          match.opponent = match.away
          match.team = match.home
        } else if (match && match.away && match.away.id === _teamKey) {
          match.opponent = match.home
          match.team = match.away
        }
      }
      getLsProps()
    }

    // sportsMatch_handlers.handleSet_trueMatch(match, match_dy)
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [match_edit, match, matchKey, match_dy]);

  useEffect(() => {
    // these are all of the realtimeMatches
    if (_updatedResults) {
      const { results: _resultsMedia } = _updatedResults
      if (_resultsMedia) {
        setMediaResults(_resultsMedia)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [_updatedResults]);

  const handleShow_matchOptions = (e) => {
    e && e.stopPropagation()
    seasonMatches_handlers.handleSelect_currentMatch(match_true, matchDisplayTypes.matchOptions)
  }

  const handleFilterOpponent = (e, t) => {
    e && e.preventDefault()
    e && e.stopPropagation()
    const opponentKey = match_true[t].id
    if (_teamKey !== opponentKey) {
      handleFilter_matches({ selectedOpponent: selectedOpponent ? null : opponentKey })
    }
  }

  const locationIcon = (home) => <Icon color={home.id === pathViews.teams ? 'teal' : 'orange'} name={home.id === _teamKey ? 'home' : 'bus'} />
  const locationPlayoffIcon = () => <Icon color={'grey'} name={'map marker alternate'} />
  const trophyIcon = () => isPlayoff && <Icon color={'blue'} name={'trophy'} />
  const dotIcon = () => <Icon color={lsProps.lsColor} name={lsProps.lsIcon} />
  const seedLabel = (seed, section) => <Label size={'mini'} circular color={getSectionColor(section)} >{seed}</Label>

  const slIcon = () => {
    if (isPlayoff) {
      return trophyIcon()
    } else {
      return dotIcon() //<Label circular size='super-small' color={lsColor} />
    }
  }

  const handle_matchClick = (key, d) => {
    if (_allowMatchClick) {
      if (matchScheduleType === matchScheduleTypes.latest) {
        handleMatch_editClick({ key: 'matches' }, key, null, d)
      } else {
        handleMatch_editClick({ key: 'matches' }, key, null, d)
      }
    }
  }

  const _matchCns = {
    awayTeam: 'match-away',
    homeTeam: 'match-home',
    opponentFull: 'match-opponent-full',
    opponent: 'match-opponent',
    matchDate: 'match-date',
    sectionLevel: 'match-sl',
    lastDate: 'match-last-date',
    status: 'match-score-status',
    awayScore: 'match-away-score',
    homeScore: 'match-home-score',
    locationIcon: 'match-location',
    trophy: 'match-trophy',
    result: 'match-result',
    media: 'match-media',
  }

  const scoreDiv = (value, cn, icon) => {
    if (icon) {
      return <div key={uniqueKey('ms', 'sd', _itemKey)} className={cn}><Icon name={icon} /></div>
    } else {
      return <div key={uniqueKey('ms', 'sd', _itemKey)} className={cn}>{value}</div>
    }
  }

  const teamScoreBlockDiv = (display, _opponent, _matchIcon) => {
    const divs = []
    divs.push(scoreDiv(_opponent, _matchCns.opponentFull))
    divs.push(scoreDiv(null, _matchCns.locationIcon, _matchIcon))
    divs.push(scoreDiv(display, _matchCns.result))
    return divs
  }

  const scoreBlockDiv = () => {
    const divs = []
    divs.push(<div key={uniqueKey('ms', 'sbd', _itemKey, 1)} className={_matchCns.awayScore}>{teamScores.away.score}</div>)
    divs.push(<div key={uniqueKey('ms', 'sbd', _itemKey, 2)} className={_matchCns.homeScore}>{teamScores.home.score}</div>)
    divs.push(<div key={uniqueKey('ms', 'sbd', _itemKey, 3)} className={_matchCns.status}>{complete ? 'Final' : startTime}</div>)
    return divs
  }

  const matchScoreDisplay = (display) => <MatchScoreDisplay keyy={key} display={display} fullDisplay={scoreDisplay} origin={'matchSingle'} scheduleTypes={scheduleTypes} />

  const getOpponent = () => {
    let opponent;
    if (home && home.id && away && away.id) {
      if (home && home.id && _teamKey === home.id) {
        opponent = away.name
      } else if (away && away.id && _teamKey === away.id) {
        opponent = home.name
      }
    }
    return opponent
  }

  /**
   * 
   * @param {boolean} asLabel 
   * @param {boolean} allowScoreEdits 
   * @returns the score display for the match
   */
  const matchDisplayDiv = (asLabel) => {

    const _allowScore_edits = _allowEdit_scores && _allowMatchClick && (sportsMatchViewType !== sportsMatchViewTypes.singleLevel) && !forOverview

    const _opponent = getOpponent()
    const _matchIcon = home && home.id === _teamKey ? 'home' : 'bus'

    let cn_matchDisplay = 'match-display'
    // if (mediaResults) { cn_matchDisplay += ' mmr' }

    const _start_time = startTime ? startTime : '07:00 PM'

    let _startTime;
    const { hour, min } = _start_time ? timeConvertor(_start_time) : {}
    const dt = new Date()
    hour && dt.setHours(hour)
    min && dt.setMinutes(min)
    _startTime = dt ? formatItem(formatTypes.ampmShort, dt) : '--'

    let display = scoreDisplay_normal ? scoreDisplay_normal : _startTime

    if (postponed) { display = 'ppd' }
    if (cancelled) { display = 'canc' }
    if (!display) { display = 'res' }

    if (teamOnly && complete) {
      if (useScoreTeamBlock) {
        return teamScoreBlockDiv(display, _opponent, _matchIcon)
      } else {
        if (asLabel) {
          return <div key={uniqueKey(key_match, key)} className={cn_matchDisplay} ><Label onClick={(e) => { _allowScore_edits && handleShow_matchOptions(e) }}>{display}</Label></div>
        } else {
          return <div key={uniqueKey(key_match, key)} className={cn_matchDisplay} onClick={(e) => { _allowScore_edits && handleShow_matchOptions(e) }}>{display}</div>
        }
      }
    } else {
      if (useScoreBlock) {
        return scoreBlockDiv()
      } else {
        switch (sportsMatchViewType) {
          case sportsMatchViewTypes.singleLevel:
            if (_hasResults) {
              return matchScoreDisplay('Final', _allowScore_edits)
            } else {
              return matchScoreDisplay(display, _allowScore_edits)
            }
          default:
            return matchScoreDisplay(display, _allowScore_edits)
        }
      }
    }
  }

  const matchDisplayScores = () => <div key={uniqueKey(key_away, 'md', key)} className={'match-scores'}><span>{<MatchScores results={resultResults} />}</span></div>
  const rankLabel = (rank) => <Label className={'lbl-rnk'} circular size='mini'>{rank}</Label>

  const teamResult = (teamType) => {
    if (_hasResults) {
      switch (sportsMatchViewType) {
        case sportsMatchViewTypes.singleLevel:
          const _winner = _rstz && _rstz.winner ? _rstz.winner : null
          let isWinner;
          switch (teamType) {
            case 'away':
              isWinner = _winner && _winner.id === away.id
              break;
            case 'home':
              isWinner = _winner && _winner.id === home.id
              break;
            default:
            // nothing 
          }
          return <Label className='msr' size='mini' color={isWinner ? 'green' : 'grey'}>{teamScores[teamType].score}</Label>
        default:
        // nothing
      }
    }
  }

  /**
  * 
  * @param {string} cnHome
  * @param {string} key 
  * @param {string} rank 
  * @returns Name/Seed or Section
  */
  const awayDiv = (cnAway, key, rank) => {
    const _away = team ? team : away
    const cnn = _.size(_away?.name) > 16 ? ' tmm' : ''
    cnAway = cnAway += cnn
    if (isPlayoff) {
      // if this is a playoff, show the seed
      return <div key={uniqueKey(key_away, key)} className={cnAway}>
        {_showSeedsOnLine && seedLabel(_away.seed ? _away.seed : '-', _away.sections)}
        <div>{_away.name}</div>
      </div>
    } else {
      switch (sportsMatchViewType) {
        case sportsMatchViewTypes.singleLevel:
          return <div key={uniqueKey(key_away, key)} className={cnAway} onClick={(e) => { _teamKey && handleFilterOpponent(e, 'away') }}>
            <div>{showRankingsInStandings && rank ? rankLabel(rank) : null}</div>
            <div>{_away.name}</div>
            {teamResult('away')}
          </div>
        default:
          return <div key={uniqueKey(key_away, key)} className={cnAway} onClick={(e) => { _teamKey && handleFilterOpponent(e, 'away') }}>
            <div>{_away.name}</div>
            <div>{showRankingsInStandings && rank ? rankLabel(rank) : null}</div>
          </div >
      }
    }
  }

  /**
   * 
   * @param {string} cnHome
   * @param {string} key 
   * @param {string} rank 
   * @returns Name/Seed or Section
   */
  const homeDiv = (cnHome, key, rank) => {
    const _home = opponent ? opponent : home
    const cnn = _.size(_home?.name) > 16 ? ' tmm' : ''
    cnHome = cnHome += cnn
    if (isPlayoff) {
      switch (sportsMatchViewType) {
        case sportsMatchViewTypes.singleLevel:
          return <div key={uniqueKey(key_home, key)} className={cnHome}>
            {seedLabel(_home.seed ? _home.seed : '-', _home.sections)}
            <div>{_home.name}</div>
          </div>
        default:
          return <div key={uniqueKey(key_home, key)} className={cnHome}>
            <div>{_home.name}</div>
            {_showSeedsOnLine && seedLabel(_home.seed ? _home.seed : '-', _home.sections)}
          </div>
      }
    } else {
      return <div key={uniqueKey(key_home, key)} className={cnHome} onClick={(e) => { _teamKey && handleFilterOpponent(e, 'home') }}>
        <div>{showRankingsInStandings && rank ? rankLabel(rank) : null}</div>
        <div>{_home.name}</div>
        {teamResult('home')}
      </div>
    }
  }

  const pendingAwayDiv = (pending, cnAway, key) => {
    const { poolName, matchNumber, place, originalSeed } = pending
    const value = poolName + ' #' + matchNumber + '/' + place
    return <div key={uniqueKey(key_away, key)} className={cnAway}>{seedLabel(originalSeed ? originalSeed : '-')}{value}</div>
  }

  const pendingHomeDiv = (pending, cnHome, key) => {
    const { poolName, matchNumber, place, originalSeed } = pending
    const value = poolName + ' #' + matchNumber + '/' + place
    switch (sportsMatchViewType) {
      case sportsMatchViewTypes.singleLevel:
        return <div key={uniqueKey(key_home, key)} className={cnHome}>{seedLabel(originalSeed ? originalSeed : '-')}{value}</div>
      default:
        return <div key={uniqueKey(key_home, key)} className={cnHome}>{value}{seedLabel(originalSeed ? originalSeed : '-')}</div>
    }
  }

  const playoffDiv = () => {
    let loc = _location ? _location.name : null
    if (!loc) {
      if (isPlayoff) {
        loc = home ? home.name : '---'
      }
    }
    const divs = []
    { !locIsHome && divs.push(<div key={uniqueKey(key_loc, _itemKey)} className={_matchCns.locationIcon}>{locationPlayoffIcon()}{loc}</div>) }
    return divs
  }

  const dateAndSectionDivs = () => {
    return [
      <div key={uniqueKey('ms', 'sm', 1)} className={_matchCns.matchDate}>{teamOnly ? locationIcon(home) : null} {formatItem(formatTypes.dateDayMonth, startDate)}</div>,
      <div key={uniqueKey('ms', 'sm', 2)} className={_matchCns.sectionLevel}><Label size={'mini'}>{slIcon()}{lsProps._ls}</Label></div>
    ]
  }

  const matchScoreTable = () => <div key={uniqueKey('full', 'score', key_match)} className={'match-full-score'}>
    <MatchScoreTable />
  </div>

  const match_away = (rank) => {
    if (away) {
      return awayDiv(_matchCns.awayTeam, key, rank)
    } else if (away_pending) {
      return pendingAwayDiv(away_pending, _matchCns.awayTeam, key)
    }
  }

  const match_home = (rank) => {
    if (home) {
      return homeDiv(_matchCns.homeTeam, key, rank)
    } else if (home_pending) {
      return pendingHomeDiv(home_pending, _matchCns.homeTeam, key)
    }
  }

  const content_tracker = () => <MatchTracker />


  /**
   * 
   * @param {object} ranks 
   * @param {boolean} allowMatchEdit 
   * @returns 
   */
  const match_sectionSingleLine = (ranks) => {

    const matchDivs = []

    isPlayoff && matchDivs.push(<div key={uniqueKey('ms', 'sm', 2)} className={_matchCns.sectionLevel}><Label size={'mini'}>{trophyIcon()}{lsProps._ls}</Label></div>)
    matchDivs.push(match_away(ranks.away))

    !_isPlayoff && matchDivs.push(matchDisplayDiv())

    matchDivs.push(match_home(ranks.home))

    !_.isEmpty(scoreScores) && matchDivs.push(matchDisplayScores(scoreDisplay_scores))

    // if (mediaResults) {
    //   matchDivs.push(mediaResultsDiv())
    // }

    if (_showMatchOptions) {
      matchDivs.push(<MatchOptions />)
    }

    if (_showTracker) {
      matchDivs.push(content_tracker())
    }


    return matchDivs
  }

  const match_sectionSingleLevelLine = (ranks) => {
    const m = []
    isPlayoff && m.push(<div key={uniqueKey('ms', 'sm', 2)} className={_matchCns.sectionLevel}><Label size={'mini'}>{trophyIcon()}{lsProps._ls}</Label></div>)
    m.push(match_away(ranks.away))
    !_isPlayoff && m.push(matchDisplayDiv())
    m.push(match_home(ranks.home))
    if (_showMatchOptions) {
      m.push(<MatchOptions />)
    }
    return m
  }

  const match_teamSingleLine = (ranks) => {
    const m = []
    m.push(dateAndSectionDivs())
    m.push(match_away(ranks.away))
    !_isPlayoff && m.push(matchDisplayDiv())
    m.push(match_home(ranks.home))
    scoreDisplay_scores && m.push(matchDisplayScores(scoreDisplay_scores))
    return m
  }

  const ammendCn = () => {
    if (_showMatchOptions) { sportsMatch_cn += ' mopts' }
    if (scoreScores) { sportsMatch_cn += ' scrs' }
    if (_showTracker) { sportsMatch_cn += ' mtr' }
    // const _allowScore_edits = _allowEdit_scores && _allowMatchClick && (sportsMatchViewType !== sportsMatchViewTypes.singleLevel) && !forOverview
    // if (_allowScore_edits) {
    //   { sportsMatch_cn += ' ase' }
    // }
    return sportsMatch_cn
  }

  const div_match = (matchDivs) => <div
    ref={divRef}
    key={uniqueKey('ms', 'd', _itemKey)}
    className={sportsMatch_cn}
    onClick={() => { handle_matchClick(_itemKey, { itemData: match_true }) }}>
    {matchDivs}
  </div>

  const singleMatch = () => {

    // Only call singleMatch when match_true has a value
    if (!match_true) {
      return <div>-</div>; // Return placeholder when no match is available
    }

    const segs = []

    if ((isTournament || playoffDates || match_true.matchNumber) && tournamentType && (1 === 3)) {
      const pm = <PoolMatch match={match_true} match_edit={match_edit} />
      segs.push(pm)
      return segs
    }

    const matchDivs = []

    if ((home || home_pending) && (away || away_pending)) {

      const _home = home_pending ? home_pending : home
      const _away = away_pending ? away_pending : away

      const homeSeed = seeds ? seeds['home'] : null
      const awaySeed = seeds ? seeds['away'] : null

      const _opponent = getOpponent()

      const teamIsHome = _home.id === _teamKey
      const away_upset = awaySeed > homeSeed ? true : false

      const allowMatchEdits = {
        match: (itemAccess && ((_home && itemAccess.includes(_home.id)) || (_away && itemAccess.includes(_away.id)))) ? true : false,
        sport: (itemAccess && itemAccess.includes(sportsKey)) ? true : false,
        any: false
      }

      if (allowMatchEdits.match || allowMatchEdits.sport) { allowMatchEdits.any = true }

      const ranks = {
        home: null,
        away: null
      }

      if (!isPast && _home && _home.id && teams && teams[_home.id] && teams[_home.id].currentRank) { ranks.home = teams[_home.id].currentRank }
      if (!isPast && _away && _away.id && teams && teams[_away.id] && teams[_away.id].currentRank) { ranks.away = teams[_away.id].currentRank }

      switch (matchScheduleType) {

        case matchScheduleTypes.latest:
          const _opponentName = !forSummary || (1 === 1) ? createInitials(_opponent, 3) : _opponent
          matchDivs.push(matchDisplayDiv())
          { !isSummary && matchDivs.push(<div key={uniqueKey('ms', 'ml', _itemKey)} className={_matchCns.lastDate}>{formatItem(formatTypes.dateDayMonth, startDate)}</div>) }
          matchDivs.push(<div key={uniqueKey('ms', 'ml', 'opp', _itemKey)} className={_matchCns.opponent}>{_opponentName}</div>)
          break;

        default:
          if (winner && winner.id === away.id) {
            _matchCns.awayTeam += ' winner'
            if (_isPlayoff && away_upset) { _matchCns.awayTeam += ' upset' }
          }

          if (winner && winner.id === home.id) {
            _matchCns.homeTeam += ' winner'
          }

          if (teamOnly) {
            matchDivs.push(match_teamSingleLine(ranks))
          } else {
            switch (sportsMatchViewType) {
              case sportsMatchViewTypes.singleLevel:
                matchDivs.push(match_sectionSingleLevelLine(ranks, allowMatchEdits.any))
                break;
              default:
                matchDivs.push(match_sectionSingleLine(ranks, allowMatchEdits.any))
            }
          }

          if (isPlayoff) {
            matchDivs.push(playoffDiv(true))
            hasScores && showMatchScoreTable && matchDivs.push(matchScoreTable())
          }

          if (match_true && match_true._results_realtime) {
            matchDivs.push(<MatchResultsRt match={match_true} />)
            sportsMatch_cn += ' rtm-current'
          }
      }

      ammendCn(allowMatchEdits, teamIsHome)

      if (isVisible) {
        segs.push(div_match(matchDivs))
      }
    }

    return segs
  }

  const memoizedSingleMatch = useMemo(() => {
    return singleMatch();
  }, [
    match_true,
    // home,
    // away,
    // seeds,
    // teams,
    matchScheduleType,
    sportsMatchViewType,
    // isTournament,
    // playoffDates,
    // tournamentType,
    // itemAccess,
    // sportsKey
  ]);

  return memoizedSingleMatch

}

export default MatchSingle